export enum SchemaType {
   String = 'string',
   Boolean = 'boolean',
   Number = 'nubmer'
}
